import { PostModel } from '$store/models';
import { useDecryptKey } from './useDecryptKey';

export const useCanViewPost = (post: PostModel) => {
  const decryptKey = useDecryptKey(post);
  return decryptKey !== undefined;
};
